import ENVIRONMENT from '@/environments/environment';
import { ActivatedLoan } from '@/interfaces/CreditProposalInterface/ActivatedLoan';
import { CustomerClassification } from '@/interfaces/CustomerInterface/CustomerInterface';

import { CreditProposalResult, CreditProposalUpdate } from '../../interfaces/CreditProposalInterface/CreditProposalInterface';
import { DecisionEngine } from '../../interfaces/DecisionInterface/DecisionInterface';
import Api from '../../utils/apiHelper';
import { Keys } from './appConfig/appConfig';
import { allResponse, CommercialOfferResult, LoanSimulationPost } from './eDniModalInterface';

const EDniModalAPI = {
  getSimulations: async (data: LoanSimulationPost): Promise<allResponse<CommercialOfferResult>> => {
    const URL = ENVIRONMENT.URL_FINANCIAL.API_FINANCIAL + ENVIRONMENT.URL_FINANCIAL.SIMULATIONS;
    const response = await Api.POST(URL, data);
    return response;
  },
  getCountryList: async (): Promise<Keys[]> => {
    const URL = ENVIRONMENT.URL_CONFIG.API_CONFIG + ENVIRONMENT.URL_CONFIG.COUNTRY_LIST;
    const response = await Api.GET(URL);
    return response.data;
  },
  getLaborStatus: async (): Promise<Keys[]> => {
    const URL = ENVIRONMENT.URL_CONFIG.API_CONFIG + ENVIRONMENT.URL_CONFIG.LABOR_STATUS;
    const response = await Api.GET(URL);
    return response.data;
  },
  getStreetTypes: async (): Promise<Keys[]> => {
    const URL = ENVIRONMENT.URL_CONFIG.API_CONFIG + ENVIRONMENT.URL_CONFIG.STREET_TYPES;
    const response = await Api.GET(URL);
    return response.data;
  },
  getCitiesByPostalCode: async (postalCode: string): Promise<any[]> => {
    const URL = ENVIRONMENT.URL_CONFIG.API_CONFIG + ENVIRONMENT.URL_CONFIG.CITIES + postalCode;
    const response = await Api.GET(URL);
    return response.data;
  },
  createProposal: async (data: any): Promise<CreditProposalResult> => {
    const URL = ENVIRONMENT.URL_PROPOSAL.API_CREDIT_PROPOSAL + ENVIRONMENT.URL_PROPOSAL.PROPOSAL;
    const response = await Api.POST(URL, data);
    return response.data;
  },

  updateProposal: async (creditProposalId: string, data: CreditProposalUpdate[]): Promise<any> => {
    const URL = `${ENVIRONMENT.URL_PROPOSAL.API_CREDIT_PROPOSAL + ENVIRONMENT.URL_PROPOSAL.PROPOSAL}/${creditProposalId}`;
    const response = await Api.PATCH(URL, data);
    return response;
  },
  postClassification: async (creditProposalId: string, data: any): Promise<CustomerClassification> => {
    const URL = `${ENVIRONMENT.URL_PROPOSAL.API_CREDIT_PROPOSAL + ENVIRONMENT.URL_PROPOSAL.PROPOSAL}/${creditProposalId}${ENVIRONMENT.URL_PROPOSAL.CUSTOMER_CLASSIFICATION}`;
    const response = await Api.POST(URL, data);
    return response.data;
  },
  getDecision: async (creditProposalId: string): Promise<DecisionEngine> => {
    const URL = `${ENVIRONMENT.URL_PROPOSAL.API_CREDIT_PROPOSAL + ENVIRONMENT.URL_PROPOSAL.PROPOSAL}/${creditProposalId}${ENVIRONMENT.URL_PROPOSAL.DECISION}`;
    const response = await Api.POST(URL);
    return response.data;
  },
  sendNotification: async (creditProposalId: string, data: any): Promise<void> => {
    const URL = `${ENVIRONMENT.URL_PROPOSAL.API_CREDIT_PROPOSAL}${ENVIRONMENT.URL_PROPOSAL.PROPOSAL}/${creditProposalId}${ENVIRONMENT.URL_PROPOSAL.NOTIFICATIONS}`;
    return Api.POST(URL, data);
  },
  activateCreditProposal: async (
    creditProposalId: string,
  ): Promise<ActivatedLoan> => {
    const URL = `${ENVIRONMENT.URL_PROPOSAL.API_CREDIT_PROPOSAL}${ENVIRONMENT.URL_PROPOSAL.PROPOSAL}/${creditProposalId}${ENVIRONMENT.URL_LOANS.LOANS}`;
    return Api.POST(URL);
  },
};

export const {
  getSimulations, getCountryList, createProposal, postClassification, getDecision, getLaborStatus, getStreetTypes, getCitiesByPostalCode, updateProposal, sendNotification, activateCreditProposal,
} = EDniModalAPI;
